<template>
  <vs-table v-if="show" ref="table" :params="params" :options="options"></vs-table>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import Constants from "../../Constants.js";
  import SelectIntermediateProducts from "../../components/SelectIntermediateProducts.vue";
  import {mapState, mapMutations, mapActions} from "vuex";
  import EventBus from "../../bus.js";
  import ClientSelect from "../../components/ClientSelect.vue";
  import VsSelect from '../../_framework/VsSelect.vue';
  import BaseService from "../../_framework/api/BaseService";
  import PsSwitch from "../../components/PsSwitch.vue";
  import CustomEntity from "../../components/CustomEntity";

  export default {
    name: "checkBook",
    components: {
      VsTable,
      SelectIntermediateProducts,
      ClientSelect,
      VsSelect,
      PsSwitch,
      CustomEntity
    },
    props: ["isSelectMode"],
    data() {
      return {
        unitItems: [],
        access: {},
        show: true,
        params: {
          entity: "checkBook",
          list: [],
          headers: {
            productCode: {
              title: "کد محصول",
              type: "number",
              isSearchable: true,
              rowAlignment: "center"
            },
            productName: {
              title: "عنوان محصول",
              type: "text",
              isSearchable: true,
              rowAlignment: "center"
            },
            unit: {
              title: "واحد",
              type: "custom",
              isSearchable: false,
              component: VsSelect,
              multiple: false,
              label: "unitValue",
              rowAlignment: "center",
              inHeader: true,
              listParams: {}
            },
            sellable: {
              title: "قابلیت فروش",
              type: "custom",
              component: PsSwitch,
              inHeader: true,
              rowAlignment: 'center'
            },
            stock: {
              title: "موجودی",
              type: "custom",
              component: CustomEntity,
              inHeader: false,
              rowAlignment: "center",

            },
            // price: {
            //   title: "قیمت",
            //   type: "number",
            //   inHeader: false,
            //   rowAlignment: "center"
            // },
            // persianDate: {
            //   title: "تاریخ تولید",
            //   type: "text",
            //   rowAlignment: "center"
            // },
            materials: {
              title: "محصولات میانی",
              type: "custom",
              component: SelectIntermediateProducts,
              rowAlignment: "center",
              // multiple: true,
              // label: "productName",
              inHeader: true
              // listParams: {
              //   requestURI: "products"
              // }
            },
          }
        },
        options: {
          isSelectMode: this.isSelectMode,
          hasActions: true,
          beforeCreateEntity: input => {
            if (input && input["materials"]) {
              input["materials"] = input["materials"].map(p => {
                return {
                  material: p.material.id,
                  percentage: p.percentage
                };
              });
            }
            if (input && input["unit"]) {
              input["unit"] = input["unit"].id || input["unit"];
            }
            this.refreshTable();
            return input;
          },
          beforeUpdateEntity: input => {
            if (input && input["materials"]) {
            }
            if (input && input["unit"]) {
              input["unit"] = input["unit"].id || input["unit"];
              this.refreshTable();
            }
            this.refreshTable();
            return input;
          },
          beforeFetchEntityList: input => {
            return input;
          },
          onRowClicked: row => {
            this.$emit("onRowSelect", row);
          },
          onRowDoubleClicked: row => {
            this.$emit("onRowDoubleClicked", row);
          },
          hasActionsInHeader: true,
          // onCreateHeaderActionClicked: () => {
          //   console.log("open modal");
          // },
          clickableRows: true,
          getTopRightButtons: () => {
            let arr = [];
            let searchToggleButton = {
              component: "search-toggle-button"
            };
            arr.push(searchToggleButton);
            return arr;
          },
          getTopLeftButtons: () => {
            let arr = [];
            let self = this;
            console.log(self.options.hasActions);
            let addItemButton = {
              component: "toggle-table-actions-button",
              params: {

                onClick() {
                  self.options.hasActions = !self.options.hasActions;
                }
              }
            };
            let stackFilterButton = {
              component: "stock-filter-button"
            };
            let sellableButton = {
              component: "sellable-button"
            };
            arr.push(sellableButton);
            arr.push(stackFilterButton);
            arr.push(addItemButton);
            return arr;
          }
        }
      };
    },
    mounted() {
      // if (this.$route && this.$route.path) {
      //   this.options.access = checkAccess(this.$route.path);
      //   console.log(this.$route.path);
      //   console.log(this.$route);
      // } else {
      //   this.options.access = checkAccess("products");
      //   console.log("fff");
      // }
      // this.show = !!this.options.access;
      // console.log(this.show);
      // this.getUnits();

      EventBus.$on("materialChanged", () => {
        this.refreshTable();
      });
    },
    computed: {
      ...mapState(["vsTableFeed"])
    },
    methods: {
      getUnits() {
        new BaseService('units', '/GetAll').getList().then((response) => {

          this.params.headers.unit.listParams.selectItems = response.data;
        }).catch((error) => {
          console.log(error)
        });
      },
      refreshTable() {
        /*this.show = false;
        setTimeout(() => {
            this.show = true;
        }, 200);*/
        // this.$refs.table.onFetchEntityList();
        // this.$refs.table.onFetchEntityList({pageIndex: this.$refs.table.list.pageIndex});
      }
    },
    watch: {}
  };
</script>
